module.exports = __webpack_public_path__ + "static/media/booking1.b3cf8c42.jpg";